//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
	searchProListByType
} from '@/service/service'

export default {
	data() {
		return {
			searchType: '',
			searchInput: '',
			searchArr: [],
			companyArr: [],
			moreType: [],
			numper: 5,
			isEmpty: false,
		}
	},
	methods: {
		toSearch(type) {
			if (this.searchInput != '') {
				let index = 0
				let data = {
					keyword: this.searchInput.toUpperCase(),
					rows: '50',
					each_rows: 6,
					search_type: 'all',
					product_type: '',
					remove_rows: '',
					currentPage: '',
				}

				if (type) {
					index = this.searchArr.findIndex((item) => { return item.id == type })
					data.rows = 5;
					data.each_rows = '';
					data.search_type = ''
					data.product_type = type
					data.currentPage = this.searchArr[index].currpage
				}

				searchProListByType(data).then(resultVo => {
					if (0 == resultVo.error_no) {
						if (type) {
							let maxpage = resultVo.DataSet1[0].totalPages
							if (this.searchArr[index].currpage < maxpage) {
								this.searchArr[index].currpage = this.searchArr[index].currpage + 1
								this.searchArr[index].maxpage = resultVo.DataSet1[0].totalPages || this.searchArr[index].maxpage
								this.searchArr[index].data = this.searchArr[index].data.concat(resultVo.DataSet0)
							} else {
								return false;
							}
						} else {
							this.searchArr = this.formatSearchData(resultVo.DataSet0);
							this.companyArr = resultVo.DataSet2;
							if (resultVo.DataSet0 == '' && resultVo.DataSet2 == '') {
								this.isEmpty = true
							} else {
								this.isEmpty = false
							}
						}
					}
				})
			}
		},
		formatSearchData(data) {
			var arr = []
			for (var key in this.constants.product_type) {
				arr.push({
					id: key,
					text: this.constants.product_type[key],
					data: [],
					tempdata:[],
					currpage: 1,
					maxpage: 1,
				})
			}
			for (var i = 0; i < data.length; i++) {
				for (var j = 0; j < arr.length; j++) {
					if (data[i].product_type == arr[j].id) {
						if(arr[j].data.length < 5) {
							arr[j].data.push(data[i])
						}
						arr[j].tempdata.push(data[i])
					}
				}
			}

			console.log(arr)

			function sortnum(a, b) {
				return a['id'].substr(0, 1) - b['id'].substr(0, 1)
			}
			return arr.sort(sortnum)
		},
		highlight(value, key) {
			if (value.indexOf(key) != -1) {
				return value.replace(key, '<em>' + key + '</em>')
			} else {
				return value
			}
		},
		switchSearchType(value) {
			this.searchType = value
			this.toSearch()
		},
		resetSearch() {
			this.searchArr = [];
			this.companyArr=[];
			this.moreType = []
		},
		goMore(id) {
			// if (id == '1fund') {
			// 	this.$router.push({
			// 		path: '/product',
			// 		query: {
			// 			search_type: '3',
			// 			search_field: this.searchText
			// 		}
			// 	})
			// } else {
			// 	this.$router.push({
			// 		path: '/product',
			// 		query: {
			// 			search_type: '2',
			// 			search_field: this.searchText
			// 		}
			// 	})
			// }
			// if(this.moreType == id) {
			// 	this.numper += 5
			// } else {
			// 	this.numper = 10
			// 	this.moreType = id;
			// }
			if (!this.moreType.indexOf(id) > -1) {
				this.moreType.push(id);
			}

			this.toSearch(id)
		},
		goRouter(type, id) {
			var path = ''
			if (type == 'fund') {
				path='/funddetail/' + id
			} else if (type == "otc") { 
				path = '/finadetail/' + id
			}
			sessionStorage.setItem('searchInput',this.searchInput)
			if(this.checkLogin || type == 'fund'){
					this.$router.push({
						path: path
					})
			}else{
				this.goLogin('/login', path)
			}
		},

		keydown(ev){
		  let that = this
			let event = ev || event
			if(event.key === "Enter" || event.keyCode == 13){
				that.resetSearch()
				that.toSearch();
			}
		}
	},
	created() {
		this.searchType = sessionStorage.getItem('searchType') || '1';
		this.searchInput = sessionStorage.getItem('searchInput') || ''
		if (this.searchInput != '') {
			this.toSearch()
		}
	},

	mounted(){
	},

	filters: {
		statusFormat(value) {
			if (value == '0') {
				return '在售'
			} else if (value == '1') {
				return '预售'
			} else if (value == '2') {
				return '结束'
			} else {
				return '--'
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/search.vue